import { Stack, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

type IStyle = {
  theme: Theme,
  disable?: boolean,
  size?: string,
  children?: JSX.Element
  onClick?: () => void
}

const LucidIcon = ({ children, disable: _disable, size: _size, theme: _theme, ...props }: IStyle) => (
  <Stack { ...props }>{ children }</Stack>
);

export const LucidIconStyle = styled(LucidIcon)(({ theme, disable, size }: IStyle) => ({
  ":hover": !disable ? {
    background: theme.customColors.backgroundPrimaryControlHover
  } : {},
  "> svg": {
    height: size ?? "0.875rem",
    width: size ?? "0.875rem"
  },
  alignItems: "center",
  background: disable
    ? `rgba(${theme.customColors.backgroundPrimaryControlDisabled})`
    // ? theme.customColors.backgroundPrimaryControlDisabled //TODO ripristinare
    : theme.customColors.backgroundPrimaryControl,
  border: `1px solid ${disable ? `rgba(${theme.customColors.borderPrimaryControlDisabled})` : theme.customColors.borderPrimaryControl}`,
  // border: `1px solid ${disable ? theme.customColors.borderPrimaryControlDisabled : theme.customColors.border}`, //TODO ripristinare
  borderRadius: "1048575rem",
  cursor: disable ? "default" : "pointer",
  display: "flex",
  height: "2.1875rem",
  justifyContent: "center",
  opacity: disable ? "0.3" : "1",
  padding: "0.0625rem",
  transition: "all 0.2s ease",
  width: "2.1875rem"
}));

export const AccessibilityButtonStyle = styled("button")(() => ({
  ":focus-visible": {
    padding: "0.4rem"
  },
  background: "none",
  border: "none",
  color: "inherit",
  cursor: "pointer",
  font: "inherit",
  padding: "0rem"
}));

